import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios, { AxiosResponse } from "axios";
import { useTranslation } from "react-i18next";
import { ThesesContent } from "../DTOs/responses/thesis";

type ThesesResponse = AxiosResponse<ThesesContent>;

export const useTheses = (): UseQueryResult<ThesesContent> => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const fetchTheses = (): Promise<ThesesResponse> => {
    const headers = {
      Accept: "*/*",
      "Accept-Language": language,
    };

    return axios.get(`${process.env.REACT_APP_BASE_URL}/thesis`, {
      headers,
    });
  };

  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["theses-get", language],
    queryFn: fetchTheses,
    select: (data) => data.data,
  });
};
